import React from "react";
import styles from "./ShowcaseSection.module.scss";
import { useInView } from "../../hooks/useInView";
import { t } from "../../i18n";

const ShowcaseSection: React.FC = () => {
  const [ref, inView] = useInView();

  return (
    <section ref={ref} className={`${styles.showcaseSection} ${styles.sectionAnimate} ${inView ? styles.inView : ""} !h-auto`}>
      {/* <div className={styles.topRow}>
        <div
          className={styles.personWrapper}
          ref={wrapperRef}
          onMouseMove={handleMouseMove}
          onMouseLeave={handleMouseLeave}
        >
          <div className={styles.blinkingCircles}>
            <span className={styles.circle}></span>
            <span className={styles.circle}></span>
            <span className={styles.circle}></span>
          </div>
          <div className={styles.personBg}></div>
          <img
            ref={imgRef}
            className={styles.personImg}
            src="/images/secondpageGuy.png"
            alt="Person"
          />
        </div>
        <div className={styles.screenshotWrapper}>
          <iframe
            className={styles.screenshotImg}
            width="520"
            height="260"
            src="https://www.youtube.com/embed/Ojhb6q0TbHs"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        </div>
      </div> */}
      <div className={`${styles.partnersSection} !m-0 !py-0 `}>
        <div className={`${styles.partnersRow}`}>
          <div className={styles.partnersRowInner}>
            {[...Array(10)].map((_, i) => (
              <React.Fragment key={i}>
                <img src="/images/teknosin.png" alt="Teknosin" />
                <img src="/images/lcw.png" alt="LC Waikiki" />
                <img src="/images/socar.png" alt="Socar" />
                <img className={styles.socarTerminalImg} src="/images/socar_terminal.png" alt="Socar Terminal" />
                <img className={styles.starRafineriImg} src="/images/star_rafineri.png" alt="Star Rafineri" />
                <img src="/images/petkim.png" alt="Petkim" />
                <img src="/images/drd.png" alt="Filo Kiralama" />
                <img className={styles.togImg} src="/images/tog.png" alt="TG" />
                <img src="/images/Dimes_logo.svg" alt="DIMES" />
                <img src="/images/utikad.png" alt="Utikad" />
                <img src="/images/boltas.png" alt="Boltas" />
                <img className={styles.azImg} src="/images/azersun.png" alt="Azersun" />
                <img className={styles.tkhImg} src="/images/tkh.png" alt="TKH" />
                <img className={styles.stateTaxImg} src="/images/state_tax.png" alt="state_tax" />
                <img className={styles.tkhImg} src="/images/tlc.jpg" alt="tlc" />
                <img className={styles.bereketSigortaImg} src="/images/bereket-sigorta.jpeg" alt="Bereket Sigorta" />
                <img className={styles.bigaHomeImg} src="/images/biga-home.png" alt="Biga Home" />
                <img className={styles.biotrendImg} src="/images/biotrend.webp" alt="Biotrend" />
                <img className={styles.doganlarHoldingImg} src="/images/doganlar-holding.png" alt="Doğanlar Holding" />
                <img className={styles.doganlarMobilyaImg} src="/images/doganlar-mobilya-logo.png" alt="Doğanlar Mobilya" />
                <img className={styles.dogtasImg} src="/images/dogtas.webp" alt="Doğtaş" />
                <img className={styles.gubretasImg} src="/images/gubretas.png" alt="Gübretaş" />
                <img className={styles.kelebekImg} src="/images/kelebek.webp" alt="Kelebek" />
                <img className={styles.lovaImg} src="/images/lova.webp" alt="Lova" />
                <img className={styles.ruumStoreImg} src="/images/ruum-store.png" alt="Ruum Store" />
                <img src="/images/brunel_uni.png" alt="Brunel University" />
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ShowcaseSection;
